import React from 'react';
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from '@mui/styles/withStyles';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

import { alpha } from '@mui/material/styles';

const styles = theme => ({
    link: {
        ...theme.style.link,
        // Pas d'outline de focus : la sélection est déjà marquée par le fond coloré + le liseré gauche.
        '&:focus': {
            outline: 'none'
        }
    },

    listItem: {
        padding: '4px 4px 0px 8px',
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    },

    listItemSelected: {
        boxShadow: 'inset 4px 0 0 ' + theme.palette.selected,
        backgroundColor: alpha(theme.palette.selected, 0.08),
        '&:hover': {
            backgroundColor: alpha(theme.palette.selected, 0.12)
        }
    },

    listItemText: {
        margin: 0,
        padding: 0
    },

    selected: {
        color: theme.palette.selected
    }
});

const AdministrationDrawerListItem = ({ classes, title, href, icon, selected, allowed, disable, expanded, depth }) => {

    if (!allowed)
        return null;

    let listItem = (
        <ListItem className={classNames(classes.listItem, selected && classes.listItemSelected)} disabled={disable}>
            <ListItemIcon sx={{ m: 0, ml:(expanded ? 4 : 1)*depth, p: 0, minWidth: '32px' }}>
                {icon}
            </ListItemIcon>

            {expanded && (
                <ListItemText
                    primary={title}
                    primaryTypographyProps={{
                        className : classNames(classes.listItemText, selected && classes.selected)
                    }}
                />
            )}

        </ListItem>
    );

    if (disable)
        return listItem;

    return (
        <Link to={href} className={classes.link}>
            {listItem}
        </Link>
    );
};


AdministrationDrawerListItem.defaultProps = ({
    allowed: true,
    depth:0
});

AdministrationDrawerListItem.propTypes = ({
    classes: PropTypes.object.isRequired,

    title: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    icon: PropTypes.element.isRequired,

    expanded: PropTypes.bool.isRequired,
    selected: PropTypes.bool.isRequired,
    allowed: PropTypes.bool.isRequired,
    disable: PropTypes.bool,

    depth: PropTypes.number
});

export default withStyles(styles)(AdministrationDrawerListItem);